import EditorFrame from "@/components/editors/EditorFrame";
import HeadingContent from "@/components/editors/template-blocks/heading/heading-items/HeadingContent";
import { HeadingTypeTemplate as IHeadingTypeTemplate } from "@/states/page-editor/template-parts/heading";

interface Props {
  part: IHeadingTypeTemplate;
}

export default function ServiceHeadingTemplate({ part }: Props) {
  return (
    <div
      className={`mx-[-16px] px-[16px] md:mx-[calc((-100vw+920px)/2)] md:px-[calc((100vw-920px)/2)]`}
      style={part.bgCssProperties}
    >
      <EditorFrame noBorder>
        <div className="py-6">
          <ContentEditor part={part} />
        </div>
      </EditorFrame>
    </div>
  );
}

interface ContentEditorProps {
  part: IHeadingTypeTemplate;
}

function ContentEditor({ part }: ContentEditorProps) {
  switch (part.type) {
    case "menu.eventSeminar":
    case "menu.form":
    case "menu.subscription":
      return <HeadingContent part={part} />;
    default:
      return <></>;
  }
}
